module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2024@2X.24a3a1fa.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2024@2X.png
// module id = 1160
// module chunks = 0